import React from 'react';

// Module 19 (BL-380) G2 - the M6 rule "a form that holds typed text must never lose it to a stray Escape" (closeOnEscape={false}).
// The platform popup template (ui/Modal3D) has no closeOnEscape switch of its own, and it sits on the shared ModalSurface, which is not ours to
// edit. So the Guests popups are wrapped in this: Escape is stopped on its way down (capture phase) before either the phone dialog or the
// desktop tile can act on it. The x button and the Cancel button still close the popup. Layout is untouched (display: contents).
export default function EscapeGuard({ children }) {
    const block = (event) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    return <div style={{ display: 'contents' }} data-escape-guard="true" onKeyDownCapture={block}>{children}</div>;
}
